import { render, staticRenderFns } from "./activation-of-device.vue?vue&type=template&id=8588ae14&scoped=true&"
import script from "./activation-of-device.vue?vue&type=script&lang=js&"
export * from "./activation-of-device.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8588ae14",
  null
  
)

export default component.exports